import type { BannerType } from '@sravni/react-advertisement/lib/types';

import type { TBannersList } from '../../types/advertising';
import type { GlobalState } from '../index';

export const getBannersFromStateSelector = (state: GlobalState): TBannersList => state.advertising.banners;

export const getIsLoadingBannerFromStateSelector =
  (type: BannerType) =>
  (state: GlobalState): boolean =>
    state.advertising.loadingState?.[type];
